import React from "react"
import PropTypes from "prop-types"
import { Trans } from "@lingui/react"

export const FormTitle = ({ title, style }) => {
  return (
    <div style={style}>
      <Trans id={title} >{title}</Trans>
    </div>
  )
}

FormTitle.propTypes = {
  title: PropTypes.string.isRequired,
  style: PropTypes.object,
}
